export default __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/zonademand_MX_tablet.f8b4f096.png";